import * as React from 'react';
import { URLDataProvider, TranslationsContext } from '@telia-common-components/shared';
import { AddressEventsContext } from './AddressEventsContext';
export const AddressEventsContainer = (props) => (React.createElement(URLDataProvider, null, ({ getSelfServiceLink }) => (React.createElement(TranslationsContext.Consumer, null, (translations) => (React.createElement(AddressEventsContext.Consumer, null, (events) => props.children(events, translations, getSelfServiceLink)))))));
export default AddressEventsContainer;
